const state = {
  baseConsumeData: new Map([
    ["waterConsume", "用水量（立方米）"],
    ["electricityConsume", "用电量（千瓦时）"],
    ["gasConsume", "天然气（立方米）"],
    ["gasolineConsume", "汽油（升）"],
    ["dieselConsume", "柴油（升）"],
    ["heatConsume", "热力（吨）"],
  ]),
};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
